import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../features/component/login/auth.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  isConfirmationVisible = false;
  confirmationTitle = 'Confirm Logout';
  confirmationMessage = 'Are you sure you want to logout?';

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  logout(): void {
    this.isConfirmationVisible = true;
  }

  handleConfirmLogout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
    this.isConfirmationVisible = false;
  }

  handleCancelLogout(): void {
    this.isConfirmationVisible = false;
  }
}
